import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './FiftyTwoWeekHighLow.css';
import Pagination from '../../CommonUI/Pagination/Pagination';
import { useLocalStorage } from "../../utils/useLocalStorage";
import MarketEquity from "../MarketEquity";
import { Vortex } from 'react-loader-spinner'
import CallTrackApi from "../../Activity_Track/CallTrackApi";
function AllHighLow(props) {
    const [data, setData] = useState([]);
    let optionInfoMarket = "52 Week High/Low";
    let optionTypeComp = "Daily Market Tracker";
    const [cocode, setcocode] = useLocalStorage("cocode", "");
    // const [valueLi, setValueLi] = useState("10");
    // const [valueLL, setValueLL] = useState("u");
    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [groupValue, setGroupValue] = useState("BSE");
    // const [valuebtn, setValueBtn] = useState("52WK");
    // const [valueLy, setValueLy] = useState("100");
    const [groupIndex, setGroupIndex] = useState("BSE_SENSEX");
    const [groupIndexNSE, setGroupIndexNSE] = useState("NIFTY");
    const { BaseURL } = useContext(URLstateContext);
    const [loadingshow, setloadingshow] = useState(false);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;


    useEffect(() => {
        setloadingshow(true)
        if (groupValue === "BSE") {
            const getUrl = BaseURL + "AllHighLow";

            fetch(`${getUrl}/${groupValue}/52WK/${groupIndex}/-/100`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false)
                    // console.log(getData, "getData")
                })
                .catch((error) => {
                });
        } else {
            const getUrl = BaseURL + "AllHighLow";
            fetch(`${getUrl}/${groupValue}/52WK/${groupIndexNSE}/-/100`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false)
                    //console.log(getData, "getData")
                })
                .catch((error) => {
                });
        }

        const getUrlGroup = BaseURL + "GroupMaster";
        fetch(`${getUrlGroup}/${groupValue}`)
            .then((response) => response.json())
            .then((dataG) => {
                getDataGroup = dataG.data;
                setDataGroup(getDataGroup);
                //console.log(getDataGroup, "getDataGroup")
            })
            .catch((error) => {
            });

    }, [groupValue, groupIndex, groupIndexNSE]);



    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);
    const routeChange = (event) => {
        const compcocode = event.currentTarget.dataset.id;
        const compcode_array = compcocode.split('-');
        const getCoCodeId = compcode_array[0].replace(/ /g, '-').replace('&', 'and').replace('+', '');
        setcocode(compcode_array[1]);
        window.open("/stocks/" + getCoCodeId.toLowerCase(), '_blank');
    };
CallTrackApi("52 Week High Low",window.location.href);

    return (
        <>
            <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>52 Week High / Low</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='high-loser-sc'>
                            <div className='high-header'>
                                <h2><span>52 Week High / Low</span></h2>
                            </div>
                            

                            <MarketEquity optionInfoMarket={optionInfoMarket} optionTypeComp={optionTypeComp}/>
                            <div className='high-table-main'>
                           <div className="selectDiv">
                            <div className='high-inner-select_I'>
                                
                                {/* aria-label="nse bse" */}
                                <select aria-label="nse bse" onChange={(event) => { setGroupValue(event.target.value); setGroupIndex("BSE_SENSEX"); setGroupIndexNSE("NIFTY") }}>
                                    <option value="BSE" selected>BSE</option>
                                    <option value="NSE">NSE</option>
                                </select>
                            </div>

                            <div className='high-inner-selectIndex'>
                                {(groupValue === "BSE") ?
                                    <select aria-label="bse sensex" onChange={(event) => { setGroupIndex(event.target.value) }}>
                                        {dataGroup && dataGroup.map(({ Group }) => (
                                            <option value={Group} selected={Group === "BSE_SENSEX"}>{Group}</option>
                                        )
                                        )}
                                    </select> : <select onChange={(event) => { setGroupIndexNSE(event.target.value) }}>
                                        {dataGroup && dataGroup.map(({ Group }) => (
                                            <option value={Group} selected={Group === "NIFTY"}>{Group}</option>
                                        )
                                        )}
                                    </select>}
                            </div>
                            </div>

                            {/* <hr className="hrWeek"></hr> */}
                            <div className='high-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th className='text-left'>Company Name</th>
                                            <th className='text-right'>LTP(&#8377;)</th>


                                            <th className='text-right' >High(&#8377;)</th>

                                            <th className='text-right'>High Date</th>
                                            <th className='text-right'>Low(&#8377;)</th>
                                            <th className='text-right'>Low Date</th>

                                        </tr>

                                    </thead>
                                    {(groupValue === "BSE") ?
                                        <tbody>
                                            {currentTableData && currentTableData.map(
                                                ({ lname, BTPRICE, B52HIGH, B52HDATE, B52LOW, B52LDATE, CO_CODE }) => (
                                                    <tr>
                                                        <td className="text-left"><h6 onClick={routeChange} data-id={lname + '-' + CO_CODE} tabIndex={0} >{lname}</h6> </td>
                                                        <td className="text-right"> {(BTPRICE != null) ? BTPRICE.toFixed(2) : 0}</td>
                                                        <td className="text-right"> {(B52HIGH != null) ? B52HIGH.toFixed(2) : 0}</td>
                                                        <td className="text-right"> {B52HDATE.split("T")[0]}</td>
                                                        <td className="text-right"> {(B52LOW != null) ? B52LOW.toFixed(2) : 0}</td>
                                                        <td className="text-right"> {B52LDATE.split("T")[0]}</td>

                                                    </tr>
                                                ))}
                                        </tbody> :
                                        <tbody>
                                            {currentTableData && currentTableData.map(
                                                ({ lname, NTPRICE, N52HIGH, N52HDATE, N52LOW, N52LDATE, CO_CODE }) => (
                                                    <tr>
                                                        <td className="text-left"><h6 onClick={routeChange} data-id={lname + '-' + CO_CODE}>{lname} </h6></td>
                                                        <td className="text-right"> {(NTPRICE != null) ? NTPRICE.toFixed(2) : 0}</td>
                                                        <td className="text-right"> {(N52HIGH != null) ? N52HIGH.toFixed(2) : 0}</td>
                                                        <td className="text-right"> {N52HDATE.split("T")[0]}</td>
                                                        <td className="text-right"> {(N52LOW != null) ? N52LOW.toFixed(2) : 0}</td>
                                                        <td className="text-right"> {N52LDATE.split("T")[0]}</td>

                                                    </tr>
                                                ))}
                                        </tbody>}
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}
                            {/* </div> */}
                            </div>
                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default AllHighLow;